<template>
  <el-card>
    <el-row class="common-row">
      <el-col :span="8">
        <span>名称：</span>
        <el-input
            class="search-item"
            placeholder="请输入"
            clearable
            v-model="name"
        ></el-input>
      </el-col>
      <el-col :span="14">
        <el-button class="btn-search" round icon="el-icon-search" @click="search">搜索</el-button>
      </el-col>
    </el-row>
    <el-row class="common-margin">
      <el-table
          :data="tableData"
          :max-height="tableHeight"
          style="width: 100%"
          border
      >
        <el-table-column type="index" width="80px" align="center" label="序号"> </el-table-column>
        <el-table-column prop="compositeName" align="center" label="名称"></el-table-column>
        <el-table-column prop="logo" align="center" label="图片">
          <template slot-scope="scope">
            <el-image
                v-if="scope.row.logoSrc"
                style="height: 100px"
                :src="scope.row.logoSrc"
                :preview-src-list="scope.row.logoList"
                fit="contain"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="category" align="center" label="品类"> </el-table-column>
        <el-table-column prop="address" align="center" label="地址"> </el-table-column>
        <el-table-column align="center" label="操作" width="120">
          <template slot-scope="scope">
            <el-button
                size="mini"
                type="text"
                @click="enroll(scope.row.id)"
            >报名</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes"
          :total="total"
      >
      </el-pagination>
    </el-row>
  </el-card>
</template>

<script>

export default {
  name: 'index',
  props: ['activityId', 'listType'],
  data () {
    return {
      id: '',
      tableData: [],
      tableHeight: 0,
      name: '',
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  created () {
    this.tableHeight = document.documentElement.clientHeight - 360
    this.getPageList()
  },
  methods: {
    async getPageList () {
      console.log(this.listType)
      let url = ''
      if (this.listType === '1') {
        console.log(23)
        url = '/boutiqueActivities/boutiqueActivities/productRegistrationList'
      } else if (this.listType === '2') {
        console.log(33)
        url = '/boutiqueActivities/boutiqueActivities/brandRegistrationList'
      } else if (this.listType === '3') {
        console.log(44)
      }
      let {data: res} = await this.$http.post(url, {
        name: this.name,
        activityId: this.activityId,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      })
      if (res.code === '200') {
        this.tableData = res.data.records
        this.tableData.forEach(item => {
          if (item.logo) {
            item.logoList = item.logo.split(',')
            item.logoSrc = item.logo.split(',')[0]
          } else {
            item.logoSrc = ''
            item.logoList = []
          }
        })
        this.total = Number(res.data.total)
      } else {
        this.$message.error(res.msg)
      }
    },
    async enroll (id) {
      let params = {
        activityId: this.activityId,
        sourceId: id
      }
      let url = ''
      if (this.listType === '1') {
        url = '/boutiqueActivities/boutiqueActivities/addActivityRegistration'
      } else if (this.listType === '2') {
        url = '/boutiqueActivities/boutiqueActivities/addActivityRegistrationBrand'
      }
      let { data: res } = await this.$http.post(url, params)
      if (res.code === '200') {
        this.$message.success(res.msg)
        this.$emit('updateList')
      } else {
        this.$message.error(res.msg)
      }
    },
    search () {
      this.currentPage = 1
      this.getPageList()
    },
    // 分页
    handleCurrentChange (page) {
      this.currentPage = page
      this.getPageList()
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.getPageList()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/exhibitionActivity/activityList.vue